import { ArrowLeft } from 'lucide-react';
import type { FC, MouseEventHandler } from 'react';

import { cn } from '@/utils/classUtils';

type Props = {
  label: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  className?: string;
};

/** First breadcrumb segment: back arrow + label, shared by regulatory watch document detail views. */
export const DocumentDetailBackLink: FC<Props> = ({
  label,
  onClick,
  className,
}) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      'inline-flex items-center gap-1 text-sm text-neutral-500 hover:text-neutral-700 hover:underline underline-offset-2 transition-colors shrink-0',
      className
    )}
  >
    <ArrowLeft className="h-4 w-4 shrink-0" aria-hidden />
    {label}
  </button>
);
